<template>
  <div class="otp-form">
    <!-- Dev controls - we can style this differently or hide in production -->
<!--
    <div class="dev-panel">
      <label class="dev-label">Test Scenario:</label>
      <select v-model="testScenario" class="dev-select">
        <option value="success">Success - OTP Sent</option>
        <option value="fail">Server Error</option>
        <option value="invalid-email">Invalid Email Format</option>
      </select>
    </div>
-->

    <div class="form-container">
<!--      <h2 class="title">Enter Your Email</h2>-->

      <div class="input-group">
        <input
            v-model="email"
            type="email"
            placeholder="your-email@example.com"
            :disabled="isLoading"
            required
        />
      </div>

      <div class="button-group">
        <button
            @click="requestOTP"
            :disabled="!isEmailValid || isLoading"
            class="primary-button"
        >
          <span v-if="isLoading" class="loading-spinner"></span>
          <span>{{ isLoading ? 'Sending...' : 'Request OTP' }}</span>
        </button>
      </div>

      <p v-if="errorMessage" class="error-message">
        <span class="error-icon">⚠️</span>
        {{ errorMessage }}
      </p>
    </div>
  </div>
</template>

<script>

import axios from 'axios';

export default {
  data() {
    return {
      email: "",
      errorMessage: "",
      testScenario: "",
      isLoading: false
    };
  },

  computed: {
    isEmailValid() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
    }
  },
  methods: {

    ///
    async requestOTP() {
      /// Email Fail
      if (!this.isEmailValid) {
        this.errorMessage = "Please enter a valid email.";
        return;
      }

      this.isLoading = true;
      this.errorMessage = "";

      try {

        // const endpoint = `http://localhost:8088/requestOTP/${this.testScenario}`;
        const endpoint = `https://659xtx8fv1.execute-api.us-east-1.amazonaws.com/Beta/request-otp`;
        const response = await axios.post(endpoint,
            { email: this.email }
        );

        if (response.data.success) {
          this.$emit("otpSent", this.email);
        } else {
          this.errorMessage = response.data.message;
        }

      } catch (error) {

        // if (error.response?.data?.message) {
        if (error.response?.data?.message) {
          this.errorMessage = error.response.data.message;
        } else {
          this.errorMessage = "Network error. Please check your connection.";
        }
      } finally {
        this.isLoading = false;
      }

      ///
    }

    ///
  }

  ///
};
</script>

<style scoped>
@import '@/assets/styles/supportForm.css';

.dev-panel {
  background: #1a202c;
  color: white;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.dev-label {
  display: block;
  margin-bottom: 8px;
  font-size: 0.875rem;
  color: #a0aec0;
}

.dev-select {
  width: 100%;
  padding: 8px;
  background: #2d3748;
  color: white;
  border: 1px solid #4a5568;
  border-radius: 4px;
}

.primary-button {
  width: 100%;
  padding: 12px 24px;
  background: #4299e1;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.primary-button:hover:not(:disabled) {
  background: #3182ce;
}

.primary-button:disabled {
  background: #a0aec0;
  cursor: not-allowed;
}

.error-message {
  margin-top: 16px;
  color: #e53e3e;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background: #fff5f5;
  border-radius: 6px;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 3px solid #ffffff;
  border-top: 3px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.otp-form {
  margin: 0 auto;
}

.form-container {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

</style>